<template>
    <Modal :id="'cmp-distribution-order-check_gln_modal'" @cancelled="onCancel">
        <template slot="header">{{ $t('gln_errors_remaining') }}</template>
        <template slot="body">
            <NTable class="distribution-order-check_gln_modal" :items="orders" :config="createNTableConfig({
                rowHeight: 30,
                headerStyle: 3,
            })
                " :headers="headers" :id="'distribution-order-check_gln_modal'">
                <template v-slot:item="{ item, tdcon }">
                    <tr>
                        <td v-bind="tdcon('gln_no')">
                            <span>{{ item["gln_no"] }}</span>
                        </td>
                        <td v-bind="tdcon('to_do')">
                            <span>{{ item["to_do"] }}</span>
                        </td>
                        <td v-bind="tdcon('used_as')">
                            <span>{{ item["used_as"] }}</span>
                        </td>


                    </tr>
                </template>
            </NTable>
        </template>
        <template slot="options">
            <button class="dt-button v1 s6" @click.stop="onCancel">
                {{ $t("ok") }}
            </button>
           
        </template>
    </Modal>
</template>
  
<script>
import Modal from "@dtplugins/modal/modal";
import { createTextFieldConfig } from "../../../../plugins/text-field";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { createTableHeader } from "../../../../plugins/datatable";
import { OrderService } from "../../services/order.service";
import {
    closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
export default {
    components: {
        Modal,
        NTable,
    },
    props: ['selectedEdiOrderTab'],
    async mounted() {
        const order_ids = this.selectedEdiOrderTab?.orders.map(o => o.order_id).join(',') || ''
        const res =await OrderService.checkGlnNo(order_ids);
        this.orders=res.data.orders||[];
    },
    data: function () {
        return {
            textFieldConfig: createTextFieldConfig({
                height: 42,
                showEditIconOnHover: false,
                box: true,
                showValidationIcons: false,
            }),

            formValidation: {},
             orders:[],
            new_related_lists: [],
        };
    },
    computed: {
        headers: function () {
            return [
                createTableHeader("gln_no", { f: 0.7 }),
                createTableHeader("to_do",),
                createTableHeader("used_as", { minw: 150 }),


            ];
        },


    },
    methods: {
        createNTableConfig: createNTableConfig,
        onSubmit() {

        },
        onCancel: function () {
            closeModalRoute(this);
        },
        //MARK: Methods
    },
};
</script>
  
<style lang="scss">
.cmp-distribution-order-check_gln_modal {
    .distribution-order-check_gln_modal {
        --ntable-height: 400px;
        border: 1px solid rgba(128, 128, 128, 0.158);
        background: #f8f8f8;
    }
}
</style>
  